import 'flickity-fade';
import Slider from './components/Slider';

const defaults = {
  fade: true,
  autoPlay: 4000,
  wrapAround: false,
  arrowShape: 'M58.7 20.6c.4-.4.8-.6 1.3-.6s1 .2 1.3.6c.4.4.6.9.6 1.4 0 .5-.2 1.1-.6 1.5L36.6 50.1l24.7 26.5c.7.8.7 2.1-.1 2.9-.7.7-1.9.7-2.6 0l-26.1-28c-.4-.4-.6-.9-.6-1.4 0-.5.2-1.1.6-1.4l26.2-28.1z',
};

export default class Gallery {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.Slider = new Slider(this.element, this.settings);
    this.element.classList.add('ready');
  }
}
